<template>
  <div class="location-markers">
    <div v-if="origin" class="location-marker">
      <FontAwesomeIcon
        v-if="!hideLocationIcons"
        :icon="['fas', 'map-marker-alt']"
        aria-hidden="true"
        class="text-pickup"
      />
      {{ origin.location.cityState ?? '-' }}
    </div>

    <i
      v-if="origin && destination"
      class="pi pi-arrow-right"
      aria-hidden="true"
    />

    <div v-if="destination" class="location-marker">
      <FontAwesomeIcon
        v-if="!hideLocationIcons"
        :icon="['fas', 'map-marker-alt']"
        aria-hidden="true"
        class="text-dropoff"
      />
      {{ destination.location.cityState ?? '-' }}
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { toRefs } from 'vue';

import { ShippingPoint } from '@/model';

const props = defineProps({
  origin: {
    type: Object as PropType<ShippingPoint>,
    default: () => undefined,
  },
  destination: {
    type: Object as PropType<ShippingPoint>,
    default: () => undefined,
  },
  hideLocationIcons: {
    type: Boolean,
    default: () => false,
  },
});
const { origin, destination, hideLocationIcons } = toRefs(props);
</script>

<style>
.location-markers {
  display: flex;
  gap: var(--gap-1);
  align-items: center;

  .location-marker {
    text-wrap: nowrap;
  }

  i.pi-arrow-right {
    font-size: 10px;
  }
}
</style>
